module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-select",
    class: {
      open: _vm.show, dropdown: !_vm.dropup, dropup: _vm.dropup
    }
  }, [_c('button', {
    class: ['btn', 'dropdown', _vm.dropdownToggle, _vm.btnVariant, _vm.btnSize],
    attrs: {
      "id": _vm.id,
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "show",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [_c('span', {
    staticClass: "checked-items",
    domProps: {
      "innerHTML": _vm._s(_vm.displayItem)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'dropdown-menu-right': _vm.position == 'right'
    },
    attrs: {
      "aria-labelledby": "dLabel"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', [_c('button', {
      staticClass: "dropdown-item",
      attrs: {
        "click": _vm.select(item)
      }
    }, [_vm._v(_vm._s(item.text))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a417dae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/dropdown-select.vue
// module id = 232
// module chunks = 0